var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"label":"Couleur de peau","clearable":"","items":_vm.avatarSkinColors,"item-text":"color","item-value":"@id"},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return [_c('v-chip',{style:('background-color: '+item.color)},[_vm._v("          ")])]}},{key:"selection",fn:function(ref){
var item = ref.item;
return [_c('v-chip',{style:('background-color: '+item.color)},[_vm._v("          ")])]}}]),model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})}
var staticRenderFns = []

export { render, staticRenderFns }